module.exports = __webpack_public_path__ + "static/media/BOURSE_LOGO_EN.133c18cd.png";